import { Search } from 'lucide-react';
import { formatKey } from '@/components/shared/kbd-hint';
import { Kbd } from '@/components/ui/kbd';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

export interface SidebarSearchProps {
  collapsed?: boolean;
  onOpen: () => void;
}

/** The raised white field that is really a button: it opens the command palette. */
export function SidebarSearch({ collapsed = false, onOpen }: SidebarSearchProps) {
  if (collapsed) {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={onOpen}
            aria-label="Buscar"
            className="flex size-8 items-center justify-center rounded-md border border-border bg-background text-muted-foreground shadow-inner-sm transition-colors duration-150 ease-out hover:bg-muted hover:text-foreground"
          >
            <Search className="size-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent side="right">Buscar · {formatKey('mod')}K</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <button
      type="button"
      onClick={onOpen}
      className="flex h-8 w-full items-center gap-2 rounded-md border border-border bg-background px-2 text-left shadow-inner-sm transition-colors duration-150 ease-out hover:bg-muted"
    >
      <Search className="size-4 shrink-0 text-muted-foreground" />
      <span className="min-w-0 flex-1 truncate text-sm text-muted-foreground">Buscar</span>
      <Kbd>{formatKey('mod')}K</Kbd>
    </button>
  );
}
